import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Attachments, { attachmentsPropTypes } from "common/Attachments.js";
import ContactPersons, { contactPersonsPropTypes } from "common/ContactPersons.js";
import RelatedContent, { relatedContentPropTypes } from "common/RelatedContent.js";
import ClickableDrupalContent from "common/ClickableDrupalContent.js";
import RelatedDocuments, { relatedDocumentsPropTypes } from "common/RelatedDocuments.js";
import RelatedLinks, { relatedLinksPropTypes } from "common/RelatedLinks.js";
import NodeImage from "common/NodeImage.js";
import SocialShare from "common/SocialShare.js";
import { renderUrl } from "common/utils.js";
import NodeMeta from "common/NodeMeta.js";
import { termPropTypes } from "common/Term.js";
import Wrapper from "common/Wrapper.js";
import { imagePropTypes } from "common/Image.js";

const PressRelease = ({ t, node }) => (
	<Fragment>
		<NodeMeta t={t} node={node} />
		<h1>{node.title}</h1>
		<NodeImage image={node.image} />
		<ClickableDrupalContent content={node.body} />
		<ContactPersons t={t} contactPersons={node.contactPersons} />
		<Attachments t={t} attachments={node.attachments} />
		<RelatedDocuments t={t} relatedDocuments={node.relatedDocuments} />
		<RelatedLinks t={t} relatedLinks={node.relatedLinks} />
		<Wrapper className="NodeMetadataWrapper">
			{node.number && (
				<div className="metadata">
					<div className="label">{t("PressRelease.pressReleaseNumber")}</div>
					<div>{node.number}</div>
				</div>
			)}
		</Wrapper>
		<SocialShare t={t} url={renderUrl(node.alias, node.language)} />
		<RelatedContent t={t} relatedContent={node.relatedContent} />
	</Fragment>
);

const pressReleasePropTypes = {
	type: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
	alias: PropTypes.string.isRequired,
	language: PropTypes.string.isRequired,
	languages: PropTypes.arrayOf(PropTypes.string).isRequired,
	body: PropTypes.string.isRequired,
	image: imagePropTypes,
	attachments: attachmentsPropTypes,
	relatedContent: relatedContentPropTypes,
	relatedDocuments: relatedDocumentsPropTypes,
	relatedLinks: relatedLinksPropTypes,
	date: PropTypes.number,
	number: PropTypes.string,
	theme: termPropTypes,
	contactPersons: contactPersonsPropTypes
};

PressRelease.propTypes = {
	t: PropTypes.func.isRequired,
	node: PropTypes.shape(pressReleasePropTypes)
};

export default React.memo(PressRelease);
